import Head from "next/head"
import * as React from "react"
import PropTypes from "prop-types"
import { CacheProvider } from "@emotion/react"
import { ThemeProvider } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import createEmotionCache from "../lib/createEmotionCache"
import "../styles/globals.css"
import theme from "../styles"

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache()
export default function MyApp(props: any) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props

  React.useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles: any = document.querySelector("#jss-server-side")
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles)
    }
  }, [])

  return (
    <CacheProvider value={emotionCache}>
      <Head>
        <title>Invention Idea</title>
        <meta
          name="description"
          content="Invention idea is a group of expert developers and designers who bring your idea from imagination to life."
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        {/* Facebook Meta Tags */}
        <meta property="og:url" content="https://invention-idea.sevencommunityen.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Invention Idea" />
        <meta
          property="og:description"
          content="Invention idea is a group of expert developers and designers who bring your idea from imagination to life."
        />
        <meta property="og:image" content="/images/optimize/invention-idea-social-media-meta-tags-img.webp" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="invention-idea.sevencommunityen.com" />
        <meta property="twitter:url" content="https://invention-idea.sevencommunityen.com/" />
        <meta name="twitter:title" content="Invention Idea" />
        <meta
          name="twitter:description"
          content="Invention idea is a group of expert developers and designers who bring your idea from imagination to life."
        />
        <meta name="twitter:image" content="/images/optimize/invention-idea-social-media-meta-tags-img.webp" />
      </Head>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...pageProps} />
      </ThemeProvider>
    </CacheProvider>
  )
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
  emotionCache: PropTypes.object,
}
